import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-Disabled',
    templateUrl: './Disabled.component.html',
    styleUrls: ['./Disabled.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisabledComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
